import React from 'react';

const HtmlSlide = ({ htmlContent, className = '' }) => {
    if (!htmlContent) {
        return (
            <div className={`flex items-center justify-center bg-gray-100 text-gray-400 text-sm ${className}`}>
                No HTML content
            </div>
        );
    }

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <iframe
                srcDoc={htmlContent}
                sandbox="allow-same-origin"
                title="HTML Slide"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    pointerEvents: 'none'
                }}
            />
        </div>
    );
};

export default HtmlSlide;
